// // @ts-ignore
// import React, { useState } from 'react';
// import { Form, Formik } from 'formik';
// import * as Yup from 'yup';
// import { Button, Modal, PasswordTextField } from 'src/components';
// import { useNavigate } from 'react-router-dom';
// import Service from 'src/setup/network';
// import { toastAlert } from 'src/utils/toastAlert';
// import HeadingWithCreateBtn from 'src/components/heading-with-create-btn';
// import Table from 'src/components/table';
// import { MdEdit } from 'react-icons/md';
// import useFetch from 'src/hooks/useFetch';
// import CrudIcon from 'src/components/crud-icon';
// import TextField from 'src/components/text-field';
// import Radio from 'src/components/radio';
// import { AiOutlinePlus } from 'react-icons/ai';

// interface IProps {}
// const FORM_VALIDATION = Yup.object().shape({
//   name: Yup.string().required('Tax name is required'),
//   value: Yup.number().required('Amount is required'),
//   // type: Yup.string().required('type is required'),
// });

// const TaxesTab: React.FC<IProps> = ({}) => {
//   const [showModal, setShowModal] = React.useState(false);
//   const [editTax, setEditTax] = useState(false);
//   const [editTaxData, setEditTaxData] = useState<any>([]);

//   const { data: taxesData, fetchData } = useFetch('/settings/extraCharges');
//   const handleAddTaxModal = () => {
//     setShowModal(!showModal);
//     setEditTaxData([]);
//   };

//   const handleEditTax = (data: any) => {
//     setShowModal(true);
//     setEditTax(true);
//     setEditTaxData(data);
//   };

//   const initValues = {
//     name: editTaxData ? editTaxData.name : '',
//     // type: editTaxData ? editTaxData.type : '',
//     type: 'percent',
//     value: editTaxData ? editTaxData.value : 0,
//   };

//   const handleAddTax = async (val: any) => {
//     const payload = {
//       id: editTaxData?.id,
//       ...val,
//     };
//     try {
//       if (editTax) {
//         await Service.put('/settings/extraCharges', payload);
//       } else {
//         await Service.post('/settings/extraCharges', val);
//       }
//       handleAddTaxModal();
//       toastAlert('success', 'Tax successfully created');
//       fetchData();
//     } catch (err: any) {
//       handleAddTaxModal();
//       toastAlert('error', err?.response?.data?.message);
//     }
//   };

//   const tableColumn = [
//     {
//       Header: 'Tax Name',
//       accessor: 'name',
//     },
//     {
//       Header: 'Tax Rate',
//       accessor: 'value',
//     },
//     {
//       Header: 'Action',

//       Cell: (row: any) => (
//         <CrudIcon
//           data={row?.cell?.row?.original}
//           url="settings/extraCharges"
//           fetchData={fetchData}
//         >
//           <div
//             className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
//             onClick={() => handleEditTax(row?.cell?.row?.original)}
//           >
//             <MdEdit color="#4062FF" />
//           </div>
//         </CrudIcon>
//       ),
//     },
//   ];
//   return (
//     <>
//       <div className="col-span-12 md:col-span-8">
//         <HeadingWithCreateBtn
//           icon={<AiOutlinePlus size={20} />}
//           btnTxt="Add taxes"
//           title=""
//           onClick={() => setShowModal(!showModal)}
//         />
//         <Table
//           tableColumn={tableColumn}
//           tableData={taxesData?.taxes ?? []}
//           pagination={false}
//         />
//       </div>
//       {showModal && (
//         <Modal onClick={handleAddTaxModal} title="Add Taxes">
//           <Formik
//             onSubmit={handleAddTax}
//             initialValues={initValues}
//             validationSchema={FORM_VALIDATION}
//             validateOnMount
//           >
//             {({ isSubmitting, isValid }) => (
//               <Form className="mt-5">
//                 <TextField
//                   name="name"
//                   label={'Name'}
//                   placeholder="Enter a tax name"
//                   // defaultValue={}
//                 />
//                 {/*
//                 <label htmlFor="" className="pb-3">
//                   Type
//                 </label>

//                 <div className="mt-2 mb-5">
//                   <Radio
//                     name="type"
//                     labelOne="Amount"
//                     labelTwo="Percent"
//                     valueOne="amount"
//                     valueTwo="percent"
//                     selectedValue={
//                       editTaxData && editTaxData.type === 'amount'
//                         ? 'amount'
//                         : editTaxData && editTaxData.type === 'percent'
//                         ? 'percent'
//                         : ''
//                     }
//                   />
//                 </div> */}

//                 <TextField
//                   name="value"
//                   label={'Tax %'}
//                   placeholder="Enter a tax amount"
//                   type="text"
//                 />
//                 <div className="flex items-center justify-end space-x-6">
//                   <Button
//                     type="submit"
//                     text="create tax"
//                     className="mt-6 "
//                     isSubmitting={isSubmitting}
//                     isValid={isValid}
//                     variant="primary"
//                   />
//                 </div>
//               </Form>
//             )}
//           </Formik>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default React.memo(TaxesTab);

// @ts-ignore
import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Modal, PasswordTextField } from 'src/components';
import { useNavigate } from 'react-router-dom';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import HeadingWithCreateBtn from 'src/components/heading-with-create-btn';
import Table from 'src/components/table';
import { MdEdit } from 'react-icons/md';
import useFetch from 'src/hooks/useFetch';
import CrudIcon from 'src/components/crud-icon';
import TextField from 'src/components/text-field';
import Radio from 'src/components/radio';
import { AiOutlinePlus } from 'react-icons/ai';

interface IProps {}
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string().required('Tax name is required'),
  value: Yup.number().required('Amount is required'),
  type: Yup.string().required('type is required'),
});

const TaxesTab: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(false);
  const [editTax, setEditTax] = useState(false);
  const [editTaxData, setEditTaxData] = useState<any>([]);

  const { data: taxesData, fetchData } = useFetch('/settings/extraCharges');
  const handleAddTaxModal = () => {
    setShowModal(!showModal);
    setEditTaxData([]);
  };

  const handleEditTax = (data: any) => {
    setShowModal(true);
    setEditTax(true);
    setEditTaxData(data);
  };

  const initValues = {
    name: editTaxData ? editTaxData.name : '',
    type: editTaxData ? editTaxData.type : '',
    // type: 'percent',
    value: editTaxData ? editTaxData.value : 0,
  };

  const handleAddTax = async (val: any) => {
    const payload = {
      id: editTaxData?.id,
      ...val,
    };
    try {
      if (editTax) {
        await Service.put('/settings/extraCharges', payload);
      } else {
        await Service.post('/settings/extraCharges', val);
      }
      handleAddTaxModal();
      toastAlert('success', 'Tax successfully created');
      fetchData();
    } catch (err: any) {
      handleAddTaxModal();
      toastAlert('error', err?.response?.data?.message);
    }
  };

  const tableColumn = [
    {
      Header: 'Extra Charge  Name',
      accessor: 'name',
    },
    {
      Header: 'Extra Charge Rate',
      accessor: 'value',
    },
    {
      Header: 'Action',

      Cell: (row: any) => {
        return (
          <CrudIcon
            data={row?.cell?.row?.original}
            url="settings/extraCharges"
            fetchData={fetchData}
          >
            <div
              className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
              onClick={() => handleEditTax(row?.cell?.row?.original)}
            >
              <MdEdit color="#4062FF" />
            </div>
          </CrudIcon>
        );
      },
    },
  ];
  return (
    <>
      <div className="col-span-12 md:col-span-8">
        <HeadingWithCreateBtn
          icon={<AiOutlinePlus size={20} />}
          btnTxt="Add Extra Charges"
          title=""
          onClick={() => setShowModal(!showModal)}
        />
        <Table
          tableColumn={tableColumn}
          tableData={taxesData?.extraCharges ?? []}
          pagination={false}
        />
      </div>
      {showModal && (
        <Modal
          onClick={handleAddTaxModal}
          title={editTax ? 'Edit Extra Charge' : 'Add Extra Charge'}
        >
          <Formik
            onSubmit={handleAddTax}
            initialValues={initValues}
            validationSchema={FORM_VALIDATION}
            validateOnMount
          >
            {({ isSubmitting, isValid }) => (
              <Form className="mt-5">
                <TextField
                  name="name"
                  label={'Name'}
                  placeholder="Enter a name"
                  // defaultValue={}
                />

                <label htmlFor="" className="pb-3">
                  Type
                </label>

                <div className="mt-2 mb-5">
                  <Radio
                    name="type"
                    labelOne="Amount"
                    labelTwo="Percent"
                    valueOne="amount"
                    valueTwo="percent"
                    selectedValue={
                      editTaxData && editTaxData.type === 'amount'
                        ? 'amount'
                        : editTaxData && editTaxData.type === 'percent'
                        ? 'percent'
                        : ''
                    }
                  />
                </div>

                <TextField
                  name="value"
                  label={'Tax %'}
                  placeholder="Enter a tax amount"
                  type="text"
                />
                <div className="flex items-center justify-end space-x-6">
                  <Button
                    type="submit"
                    text={editTax ? 'edit extra charge' : 'create extra charge'}
                    className="mt-6 "
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                    variant="primary"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </Modal>
      )}
    </>
  );
};

export default React.memo(TaxesTab);
